<template>
  <section>
    <div class="px-4 py-3">
      <div class="nav-style">
        <b-button class="px-0" variant="link" @click="redirectBack()">
          <b-icon class="font-weight-bold" icon="chevron-left"></b-icon>Access Request Tickets
        </b-button>
        &nbsp;/ &nbsp;Ticket Details
      </div>
      <hr class="solid mt-2" />
      <b-row class="text-center">
        <b-col class="mb-2" cols="6" lg="3" md="3" sm="6" xl="3">
          <p class="info-headers">Date</p>
          <p class="ticketDetails">
            {{ formatDate(ticket.date) }}
          </p>
        </b-col>
        <b-col class="mb-2" cols="6" lg="3" md="3" sm="6" xl="3">
          <p class="info-headers">Requested For</p>
          <p class="ticketDetails">
            <strong>{{ ticket.requestor.firstName }} {{ ticket.requestor.lastName }}</strong>

            {{ ticket.requestor.email }}
          </p>
        </b-col>
        <b-col class="mb-2" cols="6" lg="3" md="3" sm="6" xl="3">
          <p class="info-headers">Status</p>

          <status v-if="ticket['status'] === null" :status="'PENDING'" />
          <status v-else :status="ticket['status']" />
        </b-col>
        <b-col class="mb-2" cols="6" lg="3" md="3" sm="6" xl="3">
          <p class="info-headers">Requested By</p>
          <p class="ticketDetails">
            <strong>{{ ticket.requestor.firstName }} {{ ticket.requestor.lastName }}</strong>

            {{ ticket.requestor.email }}
          </p>
        </b-col>
      </b-row>
    </div>
    <app-status-table :filter="filter" :requests="ticket.requests"></app-status-table>
  </section>
</template>

<script>
  import moment from 'moment';
  import AppStatusTable from './AppStatusTable';
  import Status from '../../common/Status';

  export default {
    components: {
      AppStatusTable,
      Status,
    },
    props: {
      ticket: Object,
      filter: String,
    },
    methods: {
      formatDate(date) {
        if (date == null || date === '') {
          return '';
        } else {
          return moment(date).format('DD MMM YYYY h:mm A');
        }
      },
      redirectBack() {
        this.$emit('update:filter', '');
        this.$router.push({
          name: 'application-access',
          query: {
            option: 'view-study-access-requests',
          },
        });
      },
    },
  };
</script>
<style scoped>
  .info-headers {
    color: #005db8;
    margin: 0px;
    font-size: 18px;
    font-weight: bold;
  }
  .ticketDetails {
    font-size: 14px;
    line-height: 20px;
    color: #006a68;
    margin-bottom: 0px;
  }
</style>
